import React from 'react';
import { connect } from 'react-redux';
import classes from './ReceiptsView.scss';
import api from '../../../utils/api';
import Dialog from 'material-ui/Dialog';
import { receiptSelector } from '../selectors';
import moment from 'moment';
import FlatButton from 'material-ui/FlatButton';
import { push } from 'connected-react-router';
import StocktakingReceiptView from './StocktakingReceiptView';
import CustomerOrderReceiptView from './CustomerOrderReceiptView';
import RetourReceiptView from './RetourReceiptView';
import RearrangementReceiptView from './RearrangementReceiptView';
import PriceChangeReceiptView from './PriceChangeReceiptView';

class ReceiptView extends React.Component {
    componentDidMount = () => {
        this.props.fetchReceipt(this.props.match.params.id);
    };

    onSubmit = values => {};

    formatDate(date) {
        if (!date) {
            return '';
        }
        return moment(date).format('DD.MM.YYYY');
    }

    handleClose = () => {
        this.props.push('/receipts');
    };

    handlePrint = () => {
        this.props.downloadReceipts(this.props.receipt.get('id'));
    };

    titlePrefix = type => {
        switch (type) {
            case 'stocktaking':
                return 'Inventur';
            case 'customer_order':
                return 'Kundenbestellung';
            case 'rearrangement':
                return 'Umlagerung';
            case 'price_change':
                return 'Preisänderung';
            case 'retour':
                return 'Lieferantenretoure';
            default:
                return 'Beleg';
        }
    };

    render = () => {
        let actions = [
            <FlatButton label="Schließen" primary={true} onClick={this.handleClose} />,
            <FlatButton label="Drucken" primary={true} onClick={this.handlePrint} />,
        ];

        if (this.props.receipt.get('type') !== 'stocktaking') {
            actions = [<FlatButton label="Schließen" primary={true} onClick={this.handleClose} />];
        }

        return (
            <div className={classes.receiptDialog}>
                <Dialog
                    title={this.titlePrefix(this.props.receipt.get('type')) + ' - Beleg-Nr. ' + this.props.receipt.get('id')}
                    modal={false}
                    open={true}
                    actions={actions}
                    autoScrollBodyContent={true}
                    onRequestClose={this.handleClose}>
                    {this.props.receipt.get('type') == 'stocktaking' && <StocktakingReceiptView receipt={this.props.receipt} />}
                    {this.props.receipt.get('type') == 'rearrangement' && <RearrangementReceiptView receipt={this.props.receipt} />}
                    {this.props.receipt.get('type') == 'price_change' && <PriceChangeReceiptView receipt={this.props.receipt} />}
                    {this.props.receipt.get('type') == 'retour' && <RetourReceiptView receipt={this.props.receipt} />}
                    {this.props.receipt.get('type') == 'customer_order' && <CustomerOrderReceiptView receipt={this.props.receipt} />}
                </Dialog>
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    receipt: receiptSelector(state, props),
});

const mapDispatchToProps = dispatch => ({
    push: route => dispatch(push(route)),
    fetchReceipt: id => dispatch(api.actions.receipts.fetchReceipt({ id: id })),
    downloadReceipts: payload => dispatch(api.actions.receipts.downloadReceipt({ id: payload })),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReceiptView);
